module.exports = __webpack_public_path__ + "src/assets/img/01_backup.6b50b036.png";